import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TeamReportsEmptyState() {
    const { t } = useTranslation("project");

    return (
        <Alert severity="info">
            <Typography variant="body2" color="textSecondary">
                {t("projectReviewVisitV2.teamReportsRoute.labelNoReportsFound")}
            </Typography>
        </Alert>
    );
}
